import React from "react";
import Button from "react-bootstrap/Button";

function SettingsAction(props) {
  function copyURL() {
    let input = document.createElement("input");
    input.setAttribute("value", props.newURL);
    document.body.appendChild(input);
    input.select();
    /* Copy the text inside the text field */
    document.execCommand("copy");
    document.body.removeChild(input);

    props.showCopiedNotification();
  }

  return (
    <div className="setting-action">
      <Button
        variant="primary"
        disabled={props.disableSave}
        onClick={() => (window.location = props.newURL)}
      >
        GO TO DISPLAY
      </Button>
      <Button variant="primary" disabled={props.disableSave} onClick={copyURL}>
        COPY DISPLAY URL
      </Button>
    </div>
  );
}

export default SettingsAction;
